export enum RatingType {
    PROVIDER = "provider",
    CLIENT = "client",
}

export enum RatingContextType {
    MISSION = "mission",
    MISSION_REQUEST = "mission_request",
    INVOICE = "invoice",
    STANDALONE = "standalone",
}

/**
 * Operational dimensions surface on mission/standalone rating flows.
 * Financial dimensions surface on the finance (invoice) flow.
 * Filtering by category keeps each form scoped to dimensions the rater
 * can actually answer.
 */
export enum RatingDimensionCategory {
    OPERATIONAL = "operational",
    FINANCIAL = "financial",
}

/** Map a rating context to the dimension category that applies to it. */
export const categoryForContext = (ctx: RatingContextType): RatingDimensionCategory =>
    ctx === RatingContextType.INVOICE
        ? RatingDimensionCategory.FINANCIAL
        : RatingDimensionCategory.OPERATIONAL;

export interface RatingDimensionScore {
    dimensionConfigId: number;
    score: number;
}

export interface RatingDimensionConfig {
    ratingDimensionConfigId: number;
    label: string;
    hint: string | null;
    ratingType: RatingType;
    category: RatingDimensionCategory;
    displayOrder: number;
    isActive: boolean;
    weight: number;
    deletedAt: Date | null;
    createdAt: string;
    updatedAt: string | null;
}

export interface OrganizationRating {
    organizationRatingId: number | null;
    organizationId: number;
    organizationName?: string;
    contactId: number | null;
    contactName: string | null;
    assetId?: number | null;
    assetReferenceNumber?: string | null;
    ratingType: RatingType;
    contextType: RatingContextType;
    contextId: number | null;
    /** Backend-resolved reference number for the linked mission/request/invoice. */
    contextReferenceNumber?: string | null;
    overallRating: number;
    ratingDetails: RatingDimensionScore[];
    notes: string | null;
    deletedAt: Date | null;
    createdBy: number | null;
    createdByName: string | null;
    createdAt: string;
    updatedAt: string | null;
}

export interface OrganizationRatingSearchCriteria {
    organizationId?: number;
    contactId?: number;
    assetId?: number;
    ratingType?: RatingType;
    contextType?: RatingContextType;
    contextId?: number;
    isActive?: boolean;
    page?: number;
    pageSize?: number;
}

export interface RatingSummary {
    average: number | null;
    total: number;
}

export const RATING_LOW_THRESHOLD = 2.5;
